export default __webpack_public_path__ + "static/media/Gabriela.89b88be3.jpg";